
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { About } from "@/components/About";
import { Portfolio } from "@/components/Portfolio";
import { Contact } from "@/components/Contact";
import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { SEOHead } from "@/components/SEO";
import { OrganizationSchema, WebSiteSchema, LocalBusinessSchema } from "@/components/Schema";

const Index = () => {
  return (
    <>
      <SEOHead
        title="FortifyTek | Enterprise AI & Digital Infrastructure"
        description="Digital transformation for industry leaders. We build scalable, secure, and efficient enterprise solutions."
        keywords={[
          'Enterprise AI',
          'Digital Infrastructure',
          'NetSuite',
          'Shopify Plus',
          'System Integration',
          'Cloud Architecture'
        ]}
        canonicalUrl="https://www.fortifytek.com/"
        schemaType="Organization"
      />
      <OrganizationSchema />
      <WebSiteSchema />
      <LocalBusinessSchema />
      
      <div className="min-h-screen flex flex-col">
        <Navigation />
        <main className="flex-grow">
          <Hero />
          <Services />
          <About />
          <Portfolio />
          <Contact />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Index;
